import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';

import { actions } from './actions.module';
import { auth } from './auth.module';
import { contracts } from './contracts.module';
import { sites } from './sites.module';
import { geoNotifPermissions } from './geoNotifPermissions.module';
import { CGU } from './CGU.module';
import { history } from './history.module';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    actions,
    auth,
    contracts,
    sites,
    geoNotifPermissions,
    CGU,
    history,
  },
  plugins: [createPersistedState({ paths: ['actions', 'auth', 'contracts', 'sites', 'geoNotifPermissions', 'CGU'] })],
});

const initialDispatch = store.dispatch;

/**
 * Store in action module the last action execute except alert actions and requestAccessToken action
 */
Object.defineProperty(store, 'dispatch', {
  value(name, payload) {
    if (!name.includes('alert') && !name.includes('requestAccessToken')) {
      store.commit('actions/last_dispatched_action', { name, payload }, { root: true });
    }
    return initialDispatch(...arguments);
  },
});

/**
 * Execute last action saved in action module
 */
Object.defineProperty(store, 'retryLastAction', {
  value() {
    const { name, payload } = store.state.actions.lastDispatchAction;
    return store.dispatch(name, payload, { root: true });
  },
});

export default store;
